import React, { useState } from 'react';
import contactService from '../services/contactService';

const Contact = () => {
  const [formData, setFormData] = useState({
      firstName: '',
      lastName: '',
      region: '',
    email: '',
      phoneNumber: '',
    message: ''
  });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [validationErrors, setValidationErrors] = useState([]);

  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({
          ...prev,
          [name]: value
      }));

    // Clear errors when user starts typing
    if (errorMessage) setErrorMessage('');
    if (validationErrors.length > 0) setValidationErrors([]);
    if (submitStatus === 'error') setSubmitStatus(null);
  };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      setErrorMessage('');
      setValidationErrors([]);
      setSubmitStatus(null);

      try {
        // Submit the form using the contact service
        const result = await contactService.createContact(formData);

        if (result.success) {
          setSubmitStatus('success');
          setFormData({
            firstName: '',
            lastName: '',
            region: '',
            email: '',
            phoneNumber: '',
            message: ''
          });

          // Reset success message after 5 seconds
          setTimeout(() => setSubmitStatus(null), 5000);
        } else {
          setSubmitStatus('error');
          setErrorMessage(result.error || 'Failed to submit contact form');

          // Handle validation errors
          if (result.validationErrors && result.validationErrors.length > 0) {
            setValidationErrors(result.validationErrors);
          }
        }
      } catch (error) {
        console.error('Contact form submission error:', error);
        setSubmitStatus('error');
        setErrorMessage('An unexpected error occurred. Please try again.');
      } finally {
        setIsSubmitting(false);
      }
    };

  return (
      <div className="min-h-screen bg-slate-900 pt-32 pb-16 relative overflow-hidden">
          {/* Organic gradient overlays matching home page */}
          <div className="absolute -top-40 -right-40 w-[1000px] h-[1000px]">
            {/* Main organic blob - floating animation */}
            <div 
              className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-br from-purple-500/40 via-indigo-500/30 to-blue-500/20 rounded-full blur-3xl"
              style={{
                animation: 'float 8s ease-in-out infinite'
              }}
            ></div>
            
            {/* Secondary layer for depth - counter rotation */}
            <div 
              className="absolute top-40 right-40 w-[600px] h-[600px] bg-gradient-to-tl from-indigo-400/30 via-purple-400/20 to-violet-400/15 rounded-full blur-2xl"
              style={{
                animation: 'floatReverse 10s ease-in-out infinite'
              }}
            ></div>
            
            {/* Inner glow - subtle drift */}
            <div 
              className="absolute top-80 right-80 w-[500px] h-[500px] bg-gradient-to-br from-purple-300/25 via-indigo-300/20 to-blue-300/15 rounded-full blur-xl"
              style={{
                animation: 'drift 12s ease-in-out infinite'
              }}
            ></div>
          </div>

          {/* Subtle ambient overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-transparent to-purple-900/5"></div>

          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Header Section */}
              <div className="text-center mb-16">
                  <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 font-AfacadFluxLight">
                      Contact <span className="text-purple-400">Us</span>
                  </h1>
                  <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
                      Ready to transform your business? Get in touch with our team of experts
                      and let's discuss how we can help you achieve your goals.
                  </p>
              </div>

              {/* Contact Form */}
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-12 shadow-2xl">
                  {submitStatus === 'success' && (
                      <div className="mb-8 p-4 bg-green-500/20 border border-green-500/30 rounded-lg">
                          <p className="text-green-400 text-center font-medium">
                              Thank you! Your message has been sent successfully. We'll get back to you soon.
                          </p>
                      </div>
                  )}

          {submitStatus === 'error' && (
            <div className="mb-8 p-4 bg-red-500/20 border border-red-500/30 rounded-lg">
              <p className="text-red-400 text-center font-medium">
                {errorMessage}
              </p>
              {validationErrors.length > 0 && (
                <ul className="mt-2 text-red-300 text-sm list-disc list-inside">
                  {validationErrors.map((error, index) => (
                    <li key={index}>{error.msg || error}</li>
                  ))}
                </ul>
              )}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {/* First Name */}
                          <div>
                              <label htmlFor="firstName" className="block text-sm font-medium text-gray-300 mb-2">
                                  First Name *
                              </label>
                              <input
                                  type="text"
                                  id="firstName"
                                  name="firstName"
                                  value={formData.firstName}
                                  onChange={handleChange}
                                  required
                                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                                  placeholder="Enter your first name"
                              />
                          </div>

                          {/* Last Name */}
                          <div>
                              <label htmlFor="lastName" className="block text-sm font-medium text-gray-300 mb-2">
                                  Last Name *
                              </label>
                              <input
                                  type="text"
                                  id="lastName"
                                  name="lastName"
                                  value={formData.lastName}
                                  onChange={handleChange}
                                  required
                                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                                  placeholder="Enter your last name"
                              />
                          </div>
                      </div>

                      {/* Region */}
                      <div>
                          <label htmlFor="region" className="block text-sm font-medium text-gray-300 mb-2">
                              Region *
                          </label>
                          <select
                              id="region"
                              name="region"
                              value={formData.region}
                              onChange={handleChange}
                              required
                              className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                              style={{
                                color: 'white',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)'
                              }}
                          >
                              <option value="" className="bg-slate-800 text-white">Select your region</option>
                              <option value="north-america" className="bg-slate-800 text-white">North America</option>
                              <option value="europe" className="bg-slate-800 text-white">Europe</option>
                              <option value="asia-pacific" className="bg-slate-800 text-white">Asia Pacific</option>
                              <option value="middle-east" className="bg-slate-800 text-white">Middle East</option>
                              <option value="africa" className="bg-slate-800 text-white">Africa</option>
                              <option value="latin-america" className="bg-slate-800 text-white">Latin America</option>
                              <option value="other" className="bg-slate-800 text-white">Other</option>
                          </select>
            </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {/* Email */}
                          <div>
                              <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                                  Email *
                              </label>
                              <input
                                  type="email"
                                  id="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleChange}
                                  required
                                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                                  placeholder="Enter your email address"
                              />
                          </div>

                          {/* Phone Number */}
                          <div>
                              <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-300 mb-2">
                                  Phone Number
                              </label>
                              <input
                                  type="tel"
                                  id="phoneNumber"
                                  name="phoneNumber"
                                  value={formData.phoneNumber}
                                  onChange={handleChange}
                                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                                  placeholder="Enter your phone number"
                              />
                          </div>
                      </div>

                      {/* Message */}
            <div>
                          <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">
                              Message *
                          </label>
              <textarea
                              id="message"
                              name="message"
                value={formData.message}
                onChange={handleChange}
                              required
                              rows={6}
                              className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 resize-none"
                              placeholder="Tell us about your project or how we can help you..."
              />
            </div>

                      {/* Submit Button */}
            <div className="text-center">
              <button
                type="submit"
                              disabled={isSubmitting}
                              className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-12 py-4 rounded-lg font-medium hover:from-purple-700 hover:to-indigo-700 transform hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none font-AfacadFluxLight uppercase tracking-wide text-lg"
              >
                              {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        </div>

          </div>

          {/* CSS Animations */}
          <style jsx>{`
            @keyframes float {
              0%, 100% {
                transform: translate(0px, 0px) rotate(0deg);
              }
              33% {
                transform: translate(120px, -120px) rotate(6deg);
              }
              66% {
                transform: translate(-80px, 80px) rotate(-3deg);
              }
            }

            @keyframes floatReverse {
              0%, 100% {
                transform: translate(0px, 0px) rotate(0deg);
              }
              33% {
                transform: translate(-100px, 100px) rotate(-4deg);
              }
              66% {
                transform: translate(140px, -60px) rotate(3deg);
              }
            }

            @keyframes drift {
              0%, 100% {
                transform: translate(0px, 0px) scale(1);
              }
              25% {
                transform: translate(60px, -80px) scale(1.15);
              }
              50% {
                transform: translate(-40px, 40px) scale(0.85);
              }
              75% {
                transform: translate(80px, 60px) scale(1.08);
              }
            }
          `}</style>
      </div>
  );
};

export default Contact; 